import { render, staticRenderFns } from "./WebhooksTableRow.vue?vue&type=template&id=cfb20b52"
import script from "./WebhooksTableRow.vue?vue&type=script&lang=js"
export * from "./WebhooksTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports